export const HEX_SUMMER_BASIC = "#6f864a";
export const HEX_SUMMER = "#96b522";
export const HEX_WINTER_BASIC = "#164194";
export const HEX_WINTER_PREMIUM = "#77a5ae";